"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41035],{

/***/ 68126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BusinessPhoneSystemsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/businessPhoneSolution.webp",
    mainTitle: "Enhance Your Business Phone System Sales",
    paragraphs: [
        "The business phone systems market is projected to grow significantly, reaching $82 billion by 2029, driven by the rising demand for unified communications, VoIP technology, and cloud-based solutions. Businesses today are seeking phone systems that offer seamless integration, advanced features, and robust security.",
        "To stand out in the competitive business phone systems market, having more than just top-notch products is essential. Our expert digital marketing services can optimize your sales funnel and generate high-quality leads that turn into loyal customers. Our tailored marketing strategies are designed to expand your reach and impact, aligning with your business objectives. Fill out the form above to schedule a call with us and explore how we can help transform your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function BusinessPhoneSystemsContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Boost Your Business Phone System Leads with Zero Risk | SeveralBrands.com",
                description: description ?? "Partner with us to enhance your lead generation for business phone systems. Discover how we can boost your sales growth. Book your call today!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 96491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CreditCardProcessingContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/creditCardProcessing.webp",
    mainTitle: "Connect with Businesses Needing Your Payment Solutions",
    paragraphs: [
        "According to a recent report by Allied Market Research, the global credit card processing market is expected to reach $146.45 billion by 2030. This is fueled by the increasing adoption of cashless payments, the proliferation of e-commerce, and advancements in secure payment technologies. Businesses are seeking solutions that provide seamless integration, robust security, and efficient transaction processing.",
        "Standing out involves a strategic digital marketing approach to optimize your sales funnel and generate high-quality leads that convert into loyal customers. Our tailored marketing strategies are designed to achieve these goals, expanding your reach while aligning with your business objectives. Fill out the form above to schedule a call with us and discover how we can work together to transform your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function CreditCardProcessingContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Enhance Your Credit Card Processor Leads | SeveralBrands.com",
                description: description ?? "Tailored lead generation for CCP companies. Fill out the form to schedule a call and discover how we can help grow your business."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 60212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CrmContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/crm.webp",
    mainTitle: "Connecting CRM Solutions to the Right Businesses",
    paragraphs: [
        "The CRM market is booming, with global revenues expected to reach $145.79 billion by 2029, as businesses prioritize customer engagement and personalized experiences. The demand for CRM systems that offer seamless integration, advanced analytics, and robust security is higher than ever.",
        "Standing out in the competitive CRM market requires a strategic digital marketing approach that can optimize your sales funnel and generate high-quality leads that convert into loyal customers. We offer tailored marketing strategies designed to expand your reach and impact, aligning with your business objectives. Fill out the form above to schedule a call with us and explore how we can help transform your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function CrmContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Boost Your CRM Leads with Zero Risk | SeveralBrands.com",
                description: description ?? "Tailored lead generation for CRM companies. Fill out the form to schedule a call and discover how we can help grow your business."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 77198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DigitalCopierContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/copier.webp",
    mainTitle: "Accelerate Copier Sales with Precision Marketing",
    paragraphs: [
        "Businesses today rely heavily on advanced digital copiers to meet their operational needs, from high-volume printing to seamless integration with digital workflows. These tools are crucial for enhancing productivity and maintaining efficient office operations.",
        "Our marketing solutions are designed to help digital copier providers connect with businesses needing their products. By targeting the right audience and crafting compelling messages, we ensure that your solutions reach those who can truly benefit, driving increased engagement and business growth. By partnering with us, you can effectively communicate your unique value proposition and transform your business potential into lasting success. Fill out the form above to schedule a call and learn more.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function DigitalCopierContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Boost Copier Leads with Guaranteed Results | SeveralBrands.com",
                description: description ?? "Boost your copier sales funnel with expert lead-generation strategies. Fill out the form to connect and grow your business today."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 22214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FleetManagementContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/fleet.webp",
    mainTitle: "Grow Your Fleet Management Business",
    paragraphs: [
        "The global fleet management market is set to expand significantly, reaching $52.50 billion by 2030, according to Research and Markets. Companies are seeking fleet management systems that offer seamless integration, data analytics, and enhanced security to improve efficiency and reduce operational costs.",
        "Standing out in the competitive fleet management market requires expert digital marketing services that generate high-quality leads and enhance your sales funnel. We offer tailored marketing strategies to help you expand your reach and impact, aligning with your business goals. Fill out the form above to schedule a call with us and discover how we can transform your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function FleetManagementContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Boost Your Fleet Management Leads with Zero Risk | SeveralBrands.com",
                description: description ?? "Partner with us to enhance your lead generation for Fleet Management systems. Discover how we can boost your sales growth. Schedule a call today!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 55682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ForkLiftsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/forkLift.webp",
    mainTitle: "Drive Sales Growth with Results-Oriented Marketing",
    paragraphs: [
        "As a vital player in the forklift industry, your dealership supports essential sectors such as logistics, construction, and manufacturing. Standing out in a competitive market can be challenging, but that's where our expert digital marketing solutions come in. We specialize in attracting high-quality leads and boosting sales through targeted strategies like SEO, content marketing, and social media engagement.",
        "Our data-driven approach ensures that these marketing efforts resonate with potential customers, addressing their specific needs and pain points. Don't miss the opportunity to grow your forklift dealership. Contact us today to learn more about how our expert digital marketing services can help you boost your sales and reach new heights in the industry.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function ForkLiftsContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Uplift Forklift Sales with Targeted Marketing Solutions | SeveralBrands.com",
                description: description ?? "Partner with Several Brands to generate high-quality leads and boost your forklift sales. Schedule a call to learn how we help you grow your business."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 63644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ partnerWitUSData; },
/* harmony export */   "Z": function() { return /* binding */ ForthSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_homePage_firstSection_textImageSharedComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26784);
/* harmony import */ var _components_severalbrands_whyPartnerWithUs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64080);



const simplifyingComplexDecisions = {
    img: "/severalbrands/assets/images/wantLearnMore.webp",
    mainTitle: "Want to Learn More?",
    mainTitleClassName: "font-bold lg:text-[50px] text-[30px] lg:leading-10 text-[#351C4F] text-center lg:text-left",
    paragraphsClassName: "lg:mt-5  lg:text-[30px]  text-xl lg:leading-10 text-center lg:text-left font-light",
    paragraphs: [
        "Get our free guide, 10 Key Considerations Before Partnering With a Lead Generation Company.", 
    ],
    imgToLeft: true,
    showButton: true,
    showAnimation: true,
    guideButtonTitle: "Download for Free Now"
};
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: `At Several Brands, the businesses we work with are more than
                clients. They are key collaborators and partners. We only
                succeed if you succeed. When you partner with us, you can expect
                a comprehensive, end-to-end marketing solution that delivers
                results. From lead generation to performance marketing to
                analytics and reporting, we have the expertise to help your
                business succeed.`,
            className: "default"
        },
        {
            text: `Contact us today to learn more about how we can help you achieve
                your marketing goals.`,
            className: "mt-6  3xl:max-w-[1040px] 3xl:text-xl max-w-[740px]  font-light"
        }, 
    ],
    buttonText: "Partner With Us"
};
const partnerWitUSDataHomePage = {
    title: "Ready to Scale with Performance-Based Leads?",
    titleClassName: "max-w-[1040px] !leading-[normal]",
    paragraphs: [
        {
            text: `We tailor high-intent lead campaigns to your business development goals, using performance-based pricing rather than a flat rate. Ready to see what that looks like for your business?`,
            className: "default"
        }, 
    ],
    buttonText: "Get Your Free Consultation"
};
function ForthSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "lg:mb-52 mb-36 mt-16 lg:mt-0 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mb-20 lg:mt-28 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_homePage_firstSection_textImageSharedComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    info: simplifyingComplexDecisions
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-32 lg:mt-10 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_whyPartnerWithUs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    partnerWitUSData: partnerWitUSDataHomePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 34720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MedicalSoftwareContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/medicalSoftware.webp",
    mainTitle: "Grow Your Medical Software Business",
    paragraphs: [
        "The global medical software market is rapidly expanding, with a projected growth driven by the increasing demand for efficient healthcare solutions and technological advancements. Hospitals, clinics, and healthcare providers are seeking software that offers seamless integration, real-time data access, and improved patient outcomes.",
        "Standing out in the competitive medical software landscape requires more than just innovation; it demands a strategic marketing approach to position your company as a leader. Our tailored marketing strategies are designed to help you reach more healthcare providers, establish trust, and make a significant impact in the medical software industry. Fill out the form above to schedule a call with us and discover how we can collaborate to turn your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function MedicalSoftwareContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Elevate Your Medical Software Leads with Ease | SeveralBrands.com",
                description: description ?? "Discover how Several Brands' expert lead generation strategies can enhance your medical software business funnel. Fill out the form to connect today."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 41079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PayrollContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/payroll.webp",
    mainTitle: "Enhance Your Payroll Sales with Digital Marketing",
    paragraphs: [
        "According to Allied Market Research, the global payroll outsourcing market is projected to reach $19.58 billion by 2031, driven by the growing complexity of payroll management and the adoption of cloud-based solutions. Businesses are increasingly seeking payroll systems that offer accuracy, compliance, and enhanced security. This creates a unique opportunity for payroll service providers to showcase their value by delivering efficient and reliable solutions.",
        "Our tailored marketing services can help you reach potential clients and convert them into loyal customers. Let's work together to maximize your business potential. Fill out the form above to schedule a call and discover how our services can support your growth in the payroll industry.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function PayrollContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "We Drive High-Intent Leads to Your Payroll Business | SeveralBrands.com",
                description: description ?? "Our targeted marketing campaigns provide Payroll service companies with a steady stream of leads. Request a call now and boost your sales funnel."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 77691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PeoContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/peo.webp",
    mainTitle: "Enhance Your PEO Business with Marketing Solutions",
    paragraphs: [
        "Straits Research shows that the global PEO market is projected to reach $152.14 billion by 2031. This expansion is fueled by the growing demand for outsourcing HR services, including payroll, benefits administration, and compliance management. Businesses seek solutions that provide seamless integration, expert HR support, and enhanced employee engagement.",
        "Connecting with the right clients in the PEO market requires strategic marketing. Our tailored marketing solutions can help you expand your reach and impact while aligning with your brand values. Fill out the form above to schedule a call with us and discover how we can collaborate to transform your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function PeoContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Elevate Your PEO Leads with Zero Risk | SeveralBrands.com",
                description: description ?? "Discover how Several Brands' expert lead generation strategies can boost your PEO business funnel. Fill out the form to connect today."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 35302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PointOfSaleContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/creditCardProcessing.webp",
    mainTitle: "Amplify Your POS System Lead Pipeline",
    paragraphs: [
        "According to Grand View Research, the global POS market is projected to reach $181.47 billion by 2030. This growth is driven by the demand for mobile and contactless payment solutions and the integration of advanced technologies like AI and IoT in POS systems.",
        "Standing out in the POS market requires more than a great product; it involves using customized digital marketing techniques to connect with the right clients. Our tailored services can help you achieve these goals, enhancing your reach and impact in the market while aligning with your brand values. Fill out the form above to schedule a call with us and find out how we can work together to transform your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function PointOfSaleContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Elevate Your Point of Sale System Leads | SeveralBrands.com",
                description: description ?? "Discover how Several Brands expert lead generation strategies can help boost your POS business funnel. Fill out the form to connect today."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 39860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WideFormatPrintersContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/torts.webp",
    mainTitle: "Elevate Printer Sales with Strategic Marketing",
    paragraphs: [
        "Businesses today depend on wide format printers for their specialized needs, from large-scale graphics to high-quality architectural prints. These printers are essential for delivering precise, professional results in various industries.",
        "Our marketing solutions are explicitly crafted to help wide-format printer providers connect with businesses that require these advanced tools. By targeting the right audience and creating compelling marketing strategies, we ensure that your products reach those who can benefit most, driving engagement and business growth—partner with us to communicate your unique value proposition and unlock your business's full potential. Fill out the form above to schedule a call and learn more.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function WideFormatPrintersContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Drive More Leads for Wide Format Printers | SeveralBrands.com",
                description: description ?? "Boost your wide format printer sales with our expert lead generation strategies. Fill out the form to schedule a call and grow your business today."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ })

}]);